var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.9815,
    height: 44,
    rx: 8,
    fill: "#0F1CB7",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 32C16.45 32 15.9793 31.8043 15.588 31.413C15.1967 31.0217 15.0007 30.5507 15 30C15 29.45 15.196 28.9793 15.588 28.588C15.98 28.1967 16.4507 28.0007 17 28C17.55 28 18.021 28.196 18.413 28.588C18.805 28.98 19.0007 29.4507 19 30C19 30.55 18.8043 31.021 18.413 31.413C18.0217 31.805 17.5507 32.0007 17 32ZM27 32C26.45 32 25.9793 31.8043 25.588 31.413C25.1967 31.0217 25.0007 30.5507 25 30C25 29.45 25.196 28.9793 25.588 28.588C25.98 28.1967 26.4507 28.0007 27 28C27.55 28 28.021 28.196 28.413 28.588C28.805 28.98 29.0007 29.4507 29 30C29 30.55 28.8043 31.021 28.413 31.413C28.0217 31.805 27.5507 32.0007 27 32ZM15.2 14H29.95C30.3333 14 30.625 14.171 30.825 14.513C31.025 14.855 31.0333 15.2007 30.85 15.55L27.3 21.95C27.1167 22.2833 26.871 22.5417 26.563 22.725C26.255 22.9083 25.9173 23 25.55 23H18.1L17 25H28C28.2833 25 28.521 25.096 28.713 25.288C28.905 25.48 29.0007 25.7173 29 26C29 26.2833 28.904 26.521 28.712 26.713C28.52 26.905 28.2827 27.0007 28 27H17C16.25 27 15.6833 26.671 15.3 26.013C14.9167 25.355 14.9 24.7007 15.25 24.05L16.6 21.6L13 14H12C11.7167 14 11.4793 13.904 11.288 13.712C11.0967 13.52 11.0007 13.2827 11 13C11 12.7167 11.096 12.4793 11.288 12.288C11.48 12.0967 11.7173 12.0007 12 12H13.625C13.8083 12 13.9833 12.05 14.15 12.15C14.3167 12.25 14.4417 12.3917 14.525 12.575L15.2 14Z",
    fill: "#0F1CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.bbe7a084da01ea84c8160635112f0f34.svg";
export { ForwardRef as ReactComponent };